import { css } from '@fable/theme'
import { useStatsBox } from 'app/webview/pages/stats_profile/lib/ctx/stats_box'
import { useRef, useState } from 'react'
import { useGSAP } from '@gsap/react'
import { gsap } from 'gsap'
import { RatingComparisonChart } from './chart'

export const RatingComparisonContent = ({
  skipAnim = false,
  loaded = false,
  onScrollEnd,
  isFetching = false,
  isSuccess = false,
}: {
  skipAnim?: boolean
  loaded?: boolean
  onScrollEnd?: () => void
  isFetching?: boolean
  isSuccess?: boolean
}) => {
  const viewed = useStatsBox((s) => s.viewed)
  const scope = useRef<HTMLDivElement>(null)
  const [prevBookCount, setPrevBookCount] = useState(0)

  useGSAP(
    () => {
      const tl = gsap.timeline({ delay: 0.25 })

      if (skipAnim) {
        tl.set('.anim__rating-cover', { x: '100%' })
        return
      }

      if (!viewed || !loaded) return

      tl.to('.anim__rating-cover', {
        delay: 0.2,
        x: '100%',
        duration: 1,
        ease: 'power2.out',
      })
    },
    { scope, dependencies: [viewed, loaded] }
  )

  useGSAP(
    () => {
      const books = gsap.utils.toArray('.anim__rating-book')
      const newBooks = books.slice(prevBookCount)

      if (!newBooks.length) return
      const tl = gsap.timeline()

      if (skipAnim) {
        tl.set(newBooks, { opacity: 1, y: 0 })
        return
      }

      if (!viewed || !loaded) return

      tl.to(newBooks, {
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: 'power2.out',
        stagger: 0.1,
      })

      setPrevBookCount(books.length)
    },
    { scope, dependencies: [viewed, loaded, isSuccess] }
  )

  return (
    <div
      ref={scope}
      className={css`
        width: 100%;
      `}
    >
      <RatingComparisonChart
        onScrollEnd={onScrollEnd}
        isFetching={isFetching}
      />
    </div>
  )
}
